if(!customElements.get('custom-cart-popup')){
    class CustomCartPopup extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', this.close.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.close(e);
                    }
                })
            })

            this.setTimeoutRunning = false;
            this.popupDuration = this.dataset.duration? parseInt(this.dataset.duration) * 1000 : 10000;

            this.adjustTopPosition();
            window.addEventListener('scroll', () => {
                this.adjustTopPosition();
            }, { passive: true });
            window.addEventListener('resize', () => {
                this.adjustTopPosition();
            });
        }

        refresh(){
            this.init();
        }

        adjustTopPosition(){
            var header = document.querySelector('custom-header');

            if(!header){
                this.style.top = '0px';
                return;
            }

            var headerBottom = header.getBoundingClientRect().bottom;
            this.style.top = `${Math.max(0, headerBottom)}px`;
        }

        renderContent(product){
            var clone = this.querySelector('template').content.cloneNode(true);
            this.previouslyFocusedElement = document.activeElement;

            if(product){
                if(product.image){
                    clone.querySelector('.cart-item__image img').setAttribute('src', product.image);
                }
    
                clone.querySelectorAll('.cart-item a').forEach(item => {
                    item.setAttribute('href', product.url);
                    item.setAttribute('title', `${product.title}`);
                })
    
                clone.querySelector('.heading').innerHTML = `${product.title}`;
    
                if(clone.querySelector('.vendor'))
                    clone.querySelector('.vendor').innerHTML = `${product.vendor}`;
    
                var variant = clone.querySelector('.variant');
                if(variant){
                    var variantOptions = Array.isArray(product.variant_options)
                        ? product.variant_options.filter(option => option && option.trim().toLowerCase() !== 'default title')
                        : [];

                    if(variantOptions.length){
                        variant.textContent = variantOptions.join(', ');
                    }else{
                        variant.remove();
                    }
                }
    
                if(clone.querySelector('.recipient') && product.properties){
                    var recipient = [];
                    for(let key in product.properties){
                        if(key == 'Recipient email' && product.properties[key] != ""){
                            recipient.push(`Recipient email: ${product.properties[key]}`);
                        }else if(key == 'Recipient name' && product.properties[key] != ""){
                            recipient.push(`Recipient name: ${product.properties[key]}`);
                        }else if(key == 'Message' && product.properties[key] != ""){
                            recipient.push(`Message: ${product.properties[key]}`);
                        }
                    }
    
                    recipient = recipient.join(", \n");
                    clone.querySelector('.recipient').innerHTML = recipient;
                    clone.querySelector('.recipient').setAttribute('data-hidden', 'false');
                }
    
                clone.querySelector('[data-type="close"]').addEventListener('click', this.close.bind(this));
                clone.querySelector('[data-type="close"]').addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.close(e);
                    }
                });
            }

            this.adjustTopPosition();

            this.querySelector('.cart-popup__content').innerHTML = '';
            this.querySelector('.cart-popup__content').append(clone);

            this.addButtonEffect();
            this.open();


            this.getCartSize();
        }

        addButtonEffect(){
            this.querySelectorAll('.custom-btn, .shopify-payment-button__button--unbranded, .cart-dynamic-checkout-buttons div[role=button]').forEach((item) => {
                if(item.getAttribute('data-effect') === 'wave'){
                    const svgString = `
                    <svg class="editorial" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" width="200px">
                    <defs>
                        <path id="gentle-wave" d="M-160 44c30 0 
                            68-18 88-18s
                            68 18 88 18 
                            68-18 88-18 
                            68 18 88 18
                            v44h-352z"></path>
                    </defs>
                    <g class="parallax">
                        <use xlink:href="#gentle-wave" x="40" y="10" fill="#ffffff"></use>  
                        <use xlink:href="#gentle-wave" x="30" y="10" fill="#ffffff" fill-opacity="0.2"></use>  
                    </g>
                    </svg>`;
        
                    const parser = new DOMParser();
                    const svgElement = parser.parseFromString(svgString, 'image/svg+xml').documentElement;
        
                    const svgClone = svgElement.cloneNode(true);
                    if(!item.querySelector('svg')) item.appendChild(svgClone);
                }
                item.addEventListener("click", function(event){
                    const ripple = document.createElement('span');
                    ripple.classList.add('wave-ripple');
        
                    const rect = this.getBoundingClientRect();
                    const size = Math.max(rect.width, rect.height);
                    const x = event.clientX - rect.left - size / 2;
                    const y = event.clientY - rect.top - size / 2;
        
                    ripple.style.width = ripple.style.height = `${size}px`;
                    ripple.style.left = `${x}px`;
                    ripple.style.top = `${y}px`;
        
                    this.appendChild(ripple);
        
                    ripple.addEventListener('animationend', () => {
                        ripple.remove();
                    });
                });
            })
        }

        getCartSize(){
            const cartItemsIconUrl = `/?section_id=header-cart-icon`;

            fetch(cartItemsIconUrl)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
          
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup.trim();
                document.querySelector('custom-header .nav-item .cart-count').setAttribute('data-hidden', 'false');
            })
        }

        close(){
            this.setAttribute('data-hidden', 'true');

            if(document.querySelector('custom-header')){
                const header = document.querySelector('custom-header');
                header.setAttribute('data-open-cart-popup', 'false');
            }

            if(this.previouslyFocusedElement){
                setTimeout(() => {
                    this.previouslyFocusedElement.focus();
                }, 100);
            }
        }

        open(){
            this.setAttribute('data-hidden', 'false');
            if(this.querySelector('.heading-wrapper')){
                setTimeout(() => {
                    this.querySelector('.heading-wrapper').focus();
                }, 100);
            }
            if(this.setTimeoutRunning){
                clearTimeout(this.popupSetTimeout);
            }

            this.setTimeoutRunning = true;
            this.popupSetTimeout = setTimeout(() => {
                this.close();
                this.setTimeoutRunning = false;
            }, this.popupDuration);

            if(document.querySelector('custom-header')){
                const header = document.querySelector('custom-header');
                header.setAttribute('data-open-cart-popup', 'true');
            }

        }
    }
    customElements.define('custom-cart-popup', CustomCartPopup);
}